import Image from "next/image";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import { PLATFORM_SWITCH_BANNER_HEIGHT } from "./usePlatformSwitchBanner";

type PlatformSwitchBannerProps = {
  onSwitch: () => void;
};

const PlatformSwitchBanner = ({ onSwitch }: PlatformSwitchBannerProps) => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[1000] flex items-center justify-center gap-[10px] bg-denim px-[40px] text-white print:hidden skiptranslate"
      style={{ height: PLATFORM_SWITCH_BANNER_HEIGHT }}
    >
      <Image
        src="https://assets.smartkarma.com/icons/sparkle-white.svg"
        alt="Sparkle"
        width={16}
        height={16}
        className="shrink-0"
      />
      <span className="truncate text-[13px] md:text-[14px]">
        Beta access unlocked: the all-new Smartkarma experience.
      </span>
      <button
        type="button"
        onClick={onSwitch}
        className="shrink-0 !border-0 outline-0 rounded-[3px] bg-gradient-160 from-smart-teal to-jade px-[12px] py-[4px] text-[13px] font-medium text-white transition-all hover:from-dark-teal hover:to-dark-jade"
      >
        Try it now
        <FontAwesomeIcon icon={faArrowRight} className="ml-[8px]" />
      </button>
    </div>
  );
};

export default PlatformSwitchBanner;
